import { Link as RouterLink } from 'react-router-dom';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { AppBar, Container, Toolbar } from '@mui/material';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
// components
import Logo from '../../../components/logo';
import { MHidden } from '../../../components/@mui-extend';
import { NAV_RIBBON_HEIGHT } from '../../../components/nav-ribbon';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import navConfig from '../header/config';

// ----------------------------------------------------------------------

// Shared with SimpleLayout so the content offset can never drift from the real
// bar height (they used to be declared twice with different values).
export const APP_BAR_MOBILE = 64;
export const APP_BAR_DESKTOP = 92;

// How far the desktop bar shrinks once the page is scrolled.
const APP_BAR_DESKTOP_OFFSET = APP_BAR_DESKTOP - 12;

const RootStyle = styled(AppBar)(({ theme }) => ({
  top: NAV_RIBBON_HEIGHT,
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APP_BAR_MOBILE,
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create('height', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    minHeight: APP_BAR_DESKTOP,
    height: APP_BAR_DESKTOP,
  },
}));

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(120);

  return (
    <RootStyle
      sx={{
        ...(isOffset && {
          backgroundColor: (theme) => alpha(theme.palette.background.default, 0.88),
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          borderBottomColor: 'transparent',
          boxShadow: (theme) => theme.customShadows.z8,
        }),
      }}
    >
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            height: { lg: APP_BAR_DESKTOP_OFFSET },
            minHeight: { lg: APP_BAR_DESKTOP_OFFSET },
          }),
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <RouterLink
            to="/"
            aria-label="ASAP Marketing and Studies Consultancy home"
            style={{ display: 'inline-flex', flexShrink: 0 }}
          >
            <Logo disabledLink sx={{ height: { xs: 38, lg: 46 } }} />
          </RouterLink>

          <MHidden width="lgDown">
            <MenuDesktop navConfig={navConfig} />
          </MHidden>

          <MHidden width="lgUp">
            <MenuMobile navConfig={navConfig} />
          </MHidden>
        </Container>
      </ToolbarStyle>
    </RootStyle>
  );
}
